import { useState, useEffect } from 'react';

export default function GenerationProgress({ isGenerating, reportId }) {
  const [stage, setStage] = useState(0);
  const stages = [
    { title: 'Initializing...', description: 'Setting up report generation' },
    { title: 'Searching Market Data', description: 'Gathering industry statistics' },
    { title: 'Analyzing News Sources', description: 'Processing intelligence sources' },
    { title: 'Extracting Insights', description: 'Identifying key findings' },
    { title: 'Generating Report', description: 'Creating your professional report' },
    { title: 'Finalizing', description: 'Completing report generation' }
  ];

  useEffect(() => {
    if (isGenerating) {
      const interval = setInterval(() => {
        setStage(prev => (prev < stages.length - 1 ? prev + 1 : prev));
      }, 30000); // Change stage every 30 seconds
      
      return () => clearInterval(interval);
    } else {
      setStage(0);
    }
  }, [isGenerating]);

  if (!isGenerating) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <div className="inline-block relative">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-slate-200 border-t-slate-900"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-xs font-semibold">{Math.round((stage / (stages.length - 1)) * 100)}%</span>
            </div>
          </div>
          <h3 className="text-xl font-semibold text-slate-900 mt-4">
            {stages[stage].title}
          </h3>
          <p className="text-slate-600 text-sm mt-2">
            {stages[stage].description}
          </p>
        </div>
        
        <div className="bg-slate-50 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="text-left">
              <p className="text-sm font-medium text-slate-900">Report Generation in Progress</p>
              <p className="text-xs text-slate-600 mt-1">
                Your report is being generated with comprehensive analysis. This process typically takes 2-5 minutes. 
                Please keep this window open.
              </p>
            </div>
          </div>
        </div>

        {reportId && (
          <div className="text-xs text-slate-500 text-center">
            Report ID: {reportId.slice(0, 8)}
          </div>
        )}
      </div>
    </div>
  );
}
